import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionProfileService {
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) {}

    getMySubscription(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/subscription-profile/my-subscription`);
    }

    cancelSubscription(subscriptionId: string, options?: { cancel_at_period_end?: boolean }): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/subscription-profile/cancel`, { 
            subscriptionId,
            ...options
        });
    }

    /**
     * Cancel free trial (void authorization)
     */
    cancelTrial(subscriptionId: string): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/subscription-trial-test/void/${subscriptionId}`, {});
    }

    /**
     * Get subscription purchase history for the current user
     */
    getPurchaseHistory(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/subscription-profile/purchase-history`);
    }

    /**
     * Get all available payment plans (used to filter customer plans)
     */
    getAllPlans(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/vendor-payment-plans`);
    }

    /**
     * Get a specific plan by ID
     */
    getPlanById(planId: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/vendor-payment-plans/${planId}`);
    }

    /**
     * Create a subscription for a customer selecting a plan
     */
    createSubscription(subscriptionData: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/subscriptions/create`, subscriptionData);
    }

    /**
     * Get actual inventory counts for inventory-type features
     */
    getMySubscriptionInventoryCounts(featureCodes: string[]): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/subscription-profile/my-subscription-inventory-counts`, { featureCodes });
    }

    /**
     * Check if user's company is eligible for free trial
     */
    checkTrialEligibility(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/subscription-trial-test/check-eligibility`);
    }
}
